module.exports = __webpack_public_path__ + "img/browser-seven.338861c8.svg";